// extracted by mini-css-extract-plugin
export default {"body":"app_body__TYS-D","content":"app_content__lJqVH"};